<template>
  <div>
    <div class="login">
    <h2 class="uk-text-lead">Admin Login</h2>
      <p class="error" v-if="error">Invalid Username or Password</p>
      <form @submit.prevent="handleSubmit">
        <label for="#username">Username</label>
        <input class="uk-input" type="text" id="username" v-model="username">
        <br><br>
        <label for="#password">Password</label>
        <input class="uk-input" type="password" id="password" v-model="password">
        <br>
        <span class="remainLoggedIn">
          <input class="uk-checkbox" type="checkbox" v-model="remainLoggedIn" id="remainLoggedInInput">
          <label for="remainLoggedInInput">Remain Logged In?</label>
        </span>
        <input class="uk-button uk-button-primary" type="submit" name="" id="" value="Submit">
      </form>
    </div>
    <vk-button type="link" class="uk-align-center" v-on:click="$router.push('/')">&#171; Union Member Login</vk-button>
  </div>
</template>

<script>
import AuthApi from "@/utils/api/auth";

export default {
  name: "AdminLogin",
  data() {
    return {
      username: "",
      password: "",
      error: false,
      remainLoggedIn: false
    };
  },
  methods: {
    handleSubmit() {
      AuthApi.login(this.username, this.password)
        .then(token => {
          if (token != null && token != "") {
            console.log("Token: ", token);
            if (this.remainLoggedIn) {
              this.$cookie.set("iwl_apiToken", token, { expires: "1M" });
            } else {
              // Set cookie as session cookie if user doesn't want to remain logged in
              this.$cookie.set("iwl_apiToken", token);
            }
            this.$router.push({
              path: "/administration",
              query: { bookNum: this.bookNum }
            });
          } else {
            this.error = true;
          }
        })
        .catch(error => console.log(error))
        .finally(() => {});
    }
  }
};
</script>

<style scoped>
h2 {
  font-weight: bold;
  margin: 10px 0px;
}
.login {
  max-width: 400px;
  background-color: #eeeeee;
  border: 0px solid #999999;
  padding: 15px;
  margin: 0 auto;
  text-align: left;
}
.uk-button {
  margin-top: 20px;
}
.remainLoggedIn {
  margin-top: 10px;
  display: block;
}
.remainLoggedIn label {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_login.vue